import { render } from "./UserStatsPanel.vue?vue&type=template&id=4ae1d163&scoped=true"
import script from "./UserStatsPanel.vue?vue&type=script&lang=js"
export * from "./UserStatsPanel.vue?vue&type=script&lang=js"

import "./UserStatsPanel.vue?vue&type=style&index=0&id=4ae1d163&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae1d163"]])

export default __exports__